module.exports = __webpack_public_path__ + "static/media/print-logo-1.24792140.png";